import { render, staticRenderFns } from "./TourPrice.vue?vue&type=template&id=1396d77e&scoped=true&"
import script from "./TourPrice.vue?vue&type=script&lang=js&"
export * from "./TourPrice.vue?vue&type=script&lang=js&"
import style0 from "./TourPrice.vue?vue&type=style&index=0&id=1396d77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396d77e",
  null
  
)

component.options.__file = "TourPrice.vue"
export default component.exports